import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { FiSun, FiMoon } from 'react-icons/fi';

const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="flex h-9 w-9 items-center justify-center rounded-xs text-muted transition-colors hover:bg-surface-soft hover:text-ink dark:hover:bg-white/5 dark:hover:text-white"
      aria-label="Toggle theme"
      type="button"
    >
      {isDarkMode ? (
        <FiSun className="h-4 w-4" />
      ) : (
        <FiMoon className="h-4 w-4" />
      )}
    </button>
  );
};

export default ThemeToggle;
